import { makeStyles } from "@material-ui/core/styles";

export const autoIsolationControlBarStyles = makeStyles((theme) => ({
  controlBarWrap: {
    width: "100%",
    backgroundColor: theme.palette.background.autoIsoControlBar,
    height: 35,
  },
  innerWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  controlBarText: {
    color: theme.palette.text.autoIsoControlBar,
    fontWeight: "bold",
    marginRight: 10,
  },
  button: {
    marginRight: 10,
    color: theme.palette.text.autoIsoControlBar,
    height: 25,
    borderRadius: 3,
    border: `2px solid ${theme.palette.border.autoIsoControlBar}`,
    fontWeight: "bold",
  },
  buttonText: {
    margin: 0,
    color: theme.palette.common.white,
  },
  refreshButton: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 3,
    borderBottomRightRadius: 3,
    color: theme.palette.text.autoIsoControlBar,
    border: `2px solid ${theme.palette.border.autoIsoControlBar}`,
    borderLeft: "none !important",
    height: 25,
    fontWeight: "bold",
  },
  countButton: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 3,
    borderBottomLeftRadius: 3,
    color: theme.palette.text.autoIsoControlBar,
    border: `2px solid ${theme.palette.border.autoIsoControlBar}`,
    height: 25,
    fontWeight: "bold",
  },
  dialogActions: {
    display: "flex",
    alignItems: "center",
    padding: `${theme.shape.padding}px ${theme.shape.padding * 2}px`,
    justifyContent: "space-between",
    "& a": {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  checkboxOuterContainer: {
    display: "flex",
    flexDirection: "column",
    padding: theme.shape.padding,
  },
  checkboxInnerContainer: {
    display: "flex",
    alignItems: "center",
    "& p": {
      marginBottom: 0,
    },
  },
}));
